import { SpaceBetween } from "@cloudscape-design/components";
import Button from "@cloudscape-design/components/button";
import Modal from "@cloudscape-design/components/modal";
import { mdiAlert, mdiInformationSlabCircle } from "@mdi/js";
import { Icon } from "@mdi/react";
import React, { useEffect, useState } from "react";
import { btnDanger, btnWarn } from "../../resources/types";

export interface ConfirmProps {
    header?: string;
    subtitle?: React.ReactNode;
    show: boolean;
    action: string;
    warning: string;
    type?: string;
    onConfirm?: () => void;
    onDismiss?: () => void;
}

export const Confirm: React.FC<ConfirmProps> = ({
    header = 'Confirmar',
    show,
    subtitle,
    action = 'Confirmar',
    warning = '',
    type = 'warning',
    onConfirm,
    onDismiss,
}) => {
    const [confirmWord2, setConfirmWord2] = useState("");

    useEffect(() => {
        setConfirmWord2("");
    }, [show]);
    return (
        <Modal visible={show} size="small" header={<><Icon path={type === "warning" ? mdiAlert : mdiInformationSlabCircle} size={1} /> {" "}{header}</>}
            onDismiss={() => {
                if (onDismiss) {
                    onDismiss();
                    show = false;
                }
            }}
            footer={
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                    }}
                >
                    <Button variant="link" onClick={() => {
                        if (onDismiss) {
                            show = false;
                            onDismiss();
                        }
                    }}>Cancelar</Button>
                    <Button style={{ root: type === "warning" ? btnWarn : type === "danger" ? btnDanger : type === "info" ? null : null }}
                        variant="primary"
                        onClick={() => {
                            if (onConfirm && onDismiss) {
                                show = false;
                                onDismiss();
                                onConfirm();
                            }
                        }
                        }>{action}</Button>
                </div>
            }
        >

            <SpaceBetween size="m" direction="vertical">
                {subtitle !== "" && (
                    <div>
                        {subtitle}
                    </div>
                )}
                {warning !== "" && (
                    <strong><>{warning}</></strong>
                )}
            </SpaceBetween>
        </Modal >
    );
};

export default Confirm;
